import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icons-16-line-add-map-disabled",
  "use": "icon-icons-16-line-add-map-disabled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icons-16-line-add-map-disabled\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M4 4h16v16H4z\" /><path d=\"M0 0h24v24H0z\" /><path d=\"M11 5h2v14h-2z\" fill=\"#DADCE1\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol